__turbopack_context__.v({
  "img": "ParallaxMedia-module-scss-module__Nr7iuW__img",
  "imgContainer": "ParallaxMedia-module-scss-module__Nr7iuW__imgContainer",
  "noHover": "ParallaxMedia-module-scss-module__Nr7iuW__noHover",
});
